import { type UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { buildStsConfigBase } from 'utils/runtimeEnv';

const runtimeEnv = (window as any)._env_;
const sts: UserManagerSettings = {
  ...buildStsConfigBase(runtimeEnv, 'dec'),
  // https://authts.github.io/oidc-client-ts/classes/UserManager.html
  // solamente puede ser code
  // https://github.com/authts/oidc-client-ts/blob/main/src/OidcClient.ts
  userStore: new WebStorageStateStore({ store: localStorage })
};

export default sts;
